/* ============================================================
   Batch 9b — theme.js
   Native JS. Mobile nav, cart drawer, AJAX cart, PDP gallery.
   No dependencies.
   ============================================================ */
(function () {
  'use strict';

  var money = function (cents) {
    var f = (window.Shopify && Shopify.currency && Shopify.currency.active) ? '' : '';
    return '$' + (cents / 100).toFixed(2) + (f ? ' ' + f : '');
  };

  var on = function (el, ev, fn) { if (el) el.addEventListener(ev, fn); };
  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function lockScroll(lock) { document.body.classList.toggle('no-scroll', !!lock); }

  /* ---------------- mobile nav ---------------- */
  function initMobileNav() {
    var nav = qs('[data-mnav]');
    if (!nav) return;
    var open = function () { nav.classList.add('is-open'); lockScroll(true); };
    var close = function () { nav.classList.remove('is-open'); lockScroll(false); };
    qsa('[data-mnav-open]').forEach(function (b) { on(b, 'click', open); });
    qsa('[data-mnav-close]', nav).forEach(function (b) { on(b, 'click', close); });
    on(qs('.mnav__scrim', nav), 'click', close);
    on(document, 'keyup', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------------- cart drawer ---------------- */
  var Cart = {
    el: null,
    open: function () { if (this.el) { this.el.classList.add('is-open'); lockScroll(true); } },
    close: function () { if (this.el) { this.el.classList.remove('is-open'); lockScroll(false); } },

    init: function () {
      this.el = qs('[data-cart-drawer]');
      var self = this;
      qsa('[data-cart-open]').forEach(function (b) {
        on(b, 'click', function (e) { e.preventDefault(); self.open(); });
      });
      if (this.el) {
        qsa('[data-cart-close]', this.el).forEach(function (b) { on(b, 'click', function () { self.close(); }); });
        on(qs('.drawer__scrim', this.el), 'click', function () { self.close(); });
        // qty + remove (event delegation)
        on(this.el, 'click', function (e) {
          var btn = e.target.closest('[data-line-change]');
          if (btn) {
            var line = btn.getAttribute('data-line');
            var qty = parseInt(btn.getAttribute('data-qty'), 10);
            self.change(line, qty);
          }
        });
      }
      on(document, 'keyup', function (e) { if (e.key === 'Escape') self.close(); });

      // add-to-cart forms / buttons
      qsa('[data-add-form], .js-add-form').forEach(function (form) {
        on(form, 'submit', function (e) { e.preventDefault(); self.add(form); });
      });
      qsa('[data-add-id]').forEach(function (btn) {
        on(btn, 'click', function (e) {
          e.preventDefault();
          self.addById(btn.getAttribute('data-add-id'), 1, btn);
        });
      });

      this.refresh();
    },

    _fetch: function (url, opts) {
      return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } }, opts))
        .then(function (r) { return r.json(); });
    },

    add: function (form) {
      var self = this;
      var data = new FormData(form);
      var obj = {};
      data.forEach(function (v, k) { obj[k] = v; });
      this._fetch('/cart/add.js', { method: 'POST', body: JSON.stringify(obj) })
        .then(function () { self.refresh(true); })
        .catch(function () { window.location.href = '/cart'; });
    },

    addById: function (id, qty, btn) {
      var self = this;
      if (btn) { btn.setAttribute('disabled', ''); }
      this._fetch('/cart/add.js', { method: 'POST', body: JSON.stringify({ id: id, quantity: qty || 1 }) })
        .then(function () { self.refresh(true); })
        .catch(function () { window.location.href = '/cart'; })
        .finally(function () { if (btn) btn.removeAttribute('disabled'); });
    },

    change: function (line, qty) {
      var self = this;
      this._fetch('/cart/change.js', { method: 'POST', body: JSON.stringify({ line: parseInt(line, 10), quantity: qty }) })
        .then(function (cart) { self.render(cart); });
    },

    refresh: function (openAfter) {
      var self = this;
      this._fetch('/cart.js').then(function (cart) {
        self.render(cart);
        if (openAfter) self.open();
      });
    },

    setCount: function (n) {
      qsa('[data-cart-count]').forEach(function (el) {
        el.textContent = n;
        el.style.display = n > 0 ? '' : 'none';
      });
    },

    render: function (cart) {
      this.setCount(cart.item_count);
      var sub = qs('[data-cart-subtotal]');
      if (sub) sub.textContent = money(cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price);
      var wrap = qs('[data-cart-items]');
      if (!wrap) return;
      if (!cart.items.length) {
        wrap.innerHTML = '<div class="drawer__empty"><p class="eyebrow">Your cart is empty</p><p style="margin-top:14px">Nothing gathered yet.</p></div>';
        var f = qs('[data-cart-foot]'); if (f) f.style.display = 'none';
        return;
      }
      var f2 = qs('[data-cart-foot]'); if (f2) f2.style.display = '';
      wrap.innerHTML = cart.items.map(function (it, i) {
        var line = i + 1;
        var img = it.image
          ? '<img src="' + it.image + '" alt="' + (it.product_title || '') + '">'
          : '<div class="ph" data-label=""></div>';
        var type = it.product_type ? '<div class="line-item__cat">' + it.product_type + '</div>' : '';
        return '<div class="line-item">' +
          '<div class="line-item__media">' + img + '</div>' +
          '<div>' + type +
            '<div class="line-item__title">' + it.product_title + '</div>' +
            '<div class="line-item__price">' + money(it.final_price) + '</div>' +
            '<div class="qty">' +
              '<button data-line-change data-line="' + line + '" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease">\u2212</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button data-line-change data-line="' + line + '" data-qty="' + (it.quantity + 1) + '" aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
          '<button class="line-item__remove" data-line-change data-line="' + line + '" data-qty="0">Remove</button>' +
        '</div>';
      }).join('');
    }
  };

  /* ---------------- quantity steppers (generic, non-cart) ---------------- */
  function initQty() {
    qsa('[data-qty-stepper]').forEach(function (wrap) {
      var input = qs('input', wrap);
      qsa('[data-qty-btn]', wrap).forEach(function (btn) {
        on(btn, 'click', function () {
          var step = parseInt(btn.getAttribute('data-qty-btn'), 10);
          var v = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = v;
          var out = qs('[data-qty-val]', wrap); if (out) out.textContent = v;
        });
      });
    });
  }

  /* ---------------- PDP gallery ---------------- */
  function initGallery() {
    qsa('[data-gallery]').forEach(function (g) {
      var main = qs('[data-gallery-main] img', g) || qs('[data-gallery-main] .ph', g);
      qsa('[data-gallery-thumb]', g).forEach(function (t) {
        on(t, 'click', function () {
          qsa('[data-gallery-thumb]', g).forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          var src = t.getAttribute('data-src');
          if (main && main.tagName === 'IMG' && src) main.setAttribute('src', src);
        });
      });
    });
  }

  /* ---------------- variant selection ---------------- */
  function initVariants() {
    qsa('[data-variant-selects]').forEach(function (root) {
      var jsonEl = qs('[data-variant-json]', root);
      if (!jsonEl) return;
      var variants;
      try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

      var form = root.closest('form');
      var idInput = form ? qs('[data-variant-input]', form) : qs('[data-variant-input]');
      var info = root.closest('.pdp__info') || document;
      var priceEl = qs('[data-price]', info);
      var addBtn = form ? qs('[data-add-btn]', form) : null;
      var addLabel = addBtn ? qs('[data-add-label]', addBtn) : null;
      var mainImg = qs('[data-gallery-main] img');
      var satcPrice = qs('[data-satc-price]');
      var satcAdd = qs('[data-satc-add]');
      var satcLabel = satcAdd ? qs('[data-satc-label]', satcAdd) : null;

      function selected() {
        return qsa('[data-option-position]', root).map(function (grp) {
          var active = qs('.swatch.is-active', grp);
          return active ? active.getAttribute('data-option-value') : null;
        });
      }

      function update() {
        var sel = selected();
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === sel[i]; });
        });

        var priceHtml = match
          ? ((match.compare > match.price) ? '<del>' + money(match.compare) + '</del>' + money(match.price) : money(match.price))
          : '';
        if (priceEl && match) priceEl.innerHTML = priceHtml;
        if (satcPrice && match) satcPrice.innerHTML = priceHtml;
        if (idInput && match) idInput.value = match.id;
        var avail = match && match.available;
        if (addBtn) {
          addBtn.disabled = !avail;
          if (addLabel) addLabel.textContent = !match ? 'Unavailable' : (avail ? 'Add to Cart' : 'Sold Out');
        }
        if (satcAdd) {
          satcAdd.disabled = !avail;
          if (satcLabel) satcLabel.textContent = !match ? 'Unavailable' : (avail ? 'Add to Cart' : 'Sold Out');
        }
        if (mainImg && match && match.image) mainImg.setAttribute('src', match.image);
      }

      qsa('[data-option-position]', root).forEach(function (grp) {
        var pos = grp.getAttribute('data-option-position');
        var label = qs('[data-option-current="' + pos + '"]', info);
        qsa('.swatch', grp).forEach(function (s) {
          on(s, 'click', function () {
            qsa('.swatch', grp).forEach(function (x) { x.classList.remove('is-active'); });
            s.classList.add('is-active');
            if (label) label.textContent = s.getAttribute('data-option-value');
            update();
          });
        });
      });
    });
  }

  /* ---------------- accordion ---------------- */
  function initAccordion() {
    qsa('[data-accordion]').forEach(function (acc) {
      qsa('[data-acc-toggle]', acc).forEach(function (btn) {
        on(btn, 'click', function () {
          var open = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
      });
    });
  }

  /* ---------------- predictive search ---------------- */
  function initSearch() {
    var panel = qs('[data-search]');
    if (!panel) return;
    var input = qs('[data-search-input]', panel);
    var results = qs('[data-search-results]', panel);
    var hint = qs('[data-search-hint]', panel);
    var allUrl = '/search';
    var timer = null;

    function open() { panel.classList.add('is-open'); lockScroll(true); setTimeout(function () { input.focus(); }, 250); }
    function close() { panel.classList.remove('is-open'); lockScroll(false); }

    qsa('[data-search-open]').forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); open(); }); });
    qsa('[data-search-close]', panel).forEach(function (b) { on(b, 'click', close); });
    on(document, 'keyup', function (e) { if (e.key === 'Escape') close(); });

    function render(data, term) {
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      if (hint) hint.style.display = 'none';
      if (!products.length) {
        results.innerHTML = '<p class="search__hint" style="display:block">No matches for &ldquo;' + term + '&rdquo;</p>';
        return;
      }
      results.innerHTML = products.map(function (p) {
        var img = (p.image || (p.featured_image && p.featured_image.url));
        var media = img ? '<img src="' + img + '" alt="">' : '<div class="ph"></div>';
        var cat = p.product_type ? '<span class="pred-item__cat">' + p.product_type + '</span>' : '';
        var price = p.price ? '<span class="pred-item__price">' + p.price + '</span>' : '';
        return '<a class="pred-item" href="' + p.url + '">' +
          '<span class="pred-item__media">' + media + '</span>' +
          '<span>' + cat + '<span class="pred-item__title">' + p.title + '</span></span>' + price + '</a>';
      }).join('') + '<a class="link-underline search__all" href="' + allUrl + '?q=' + encodeURIComponent(term) + '">View all results &rarr;</a>';
    }

    on(input, 'input', function () {
      var term = input.value.trim();
      clearTimeout(timer);
      if (term.length < 2) { results.innerHTML = ''; if (hint) hint.style.display = 'block'; return; }
      timer = setTimeout(function () {
        var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) { render(d, term); })
          .catch(function () { results.innerHTML = ''; });
      }, 220);
    });
  }

  /* ---------------- quick view ---------------- */
  function initQuickView() {
    var modal = qs('[data-quickview-modal]');
    if (!modal) return;
    var mediaEl = qs('[data-qv-media]', modal);
    var bodyEl = qs('[data-qv-body]', modal);

    function open() { modal.classList.add('is-open'); lockScroll(true); }
    function close() { modal.classList.remove('is-open'); lockScroll(false); }
    qsa('[data-qv-close]', modal).forEach(function (b) { on(b, 'click', close); });
    on(document, 'keyup', function (e) { if (e.key === 'Escape') close(); });

    function fmtMoney(cents) { return money(cents); }

    function render(p) {
      var first = p.variants[0];
      mediaEl.innerHTML = p.featured_image
        ? '<img src="' + p.featured_image + '" alt="' + p.title + '">'
        : '<div class="ph clay"></div>';

      var optionsHtml = '';
      if (!(p.variants.length === 1 && p.variants[0].title === 'Default Title')) {
        optionsHtml = p.options.map(function (opt, oi) {
          var pos = oi + 1;
          var sw = (opt.values || []).map(function (val) {
            var active = first.options[oi] === val ? ' is-active' : '';
            return '<button type="button" class="swatch' + active + '" data-qv-opt="' + pos + '" data-qv-val="' + val.replace(/"/g, '&quot;') + '">' + val + '</button>';
          }).join('');
          return '<div class="pdp__opt" style="gap:10px;margin-bottom:14px"><span class="pdp__opt-label">' + (opt.name || opt) + '</span><div class="swatches" data-qv-group="' + pos + '">' + sw + '</div></div>';
        }).join('');
      }

      var desc = (p.description || '').replace(/<[^>]+>/g, ' ').trim();
      var priceHtml = (first.compare_at_price > first.price)
        ? '<del>' + fmtMoney(first.compare_at_price) + '</del>' + fmtMoney(first.price)
        : fmtMoney(first.price);

      bodyEl.innerHTML =
        (p.type ? '<span class="qv__cat">' + p.type + '</span>' : '') +
        '<h2 class="qv__title">' + p.title + '</h2>' +
        '<div class="qv__price" data-qv-price>' + priceHtml + '</div>' +
        (desc ? '<p class="qv__desc">' + desc + '</p>' : '') +
        optionsHtml +
        '<div class="pdp__buy" style="margin-top:6px"><button type="button" class="btn btn--solid btn--block" data-qv-add>' +
          (first.available ? 'Add to Cart' : 'Sold Out') + '</button></div>' +
        '<a class="link-underline" style="margin-top:14px" href="' + p.url + '">View full details &rarr;</a>';

      var current = first;
      function selectVariant() {
        var sel = qsa('[data-qv-group]', bodyEl).map(function (g) {
          var a = qs('.swatch.is-active', g); return a ? a.getAttribute('data-qv-val') : null;
        });
        current = p.variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); }) || current;
        var pe = qs('[data-qv-price]', bodyEl);
        if (pe) pe.innerHTML = (current.compare_at_price > current.price)
          ? '<del>' + fmtMoney(current.compare_at_price) + '</del>' + fmtMoney(current.price) : fmtMoney(current.price);
        var ab = qs('[data-qv-add]', bodyEl);
        if (ab) { ab.disabled = !current.available; ab.textContent = current.available ? 'Add to Cart' : 'Sold Out'; }
      }
      qsa('[data-qv-group]', bodyEl).forEach(function (g) {
        qsa('.swatch', g).forEach(function (s) {
          on(s, 'click', function () {
            qsa('.swatch', g).forEach(function (x) { x.classList.remove('is-active'); });
            s.classList.add('is-active'); selectVariant();
          });
        });
      });
      on(qs('[data-qv-add]', bodyEl), 'click', function () {
        if (current.available) { Cart.addById(current.id, 1, this); close(); }
      });
    }

    qsa('[data-quickview]').forEach(function (btn) {
      on(btn, 'click', function (e) {
        e.preventDefault(); e.stopPropagation();
        bodyEl.innerHTML = '<div class="qv__loading">Loading\u2026</div>';
        mediaEl.innerHTML = '';
        open();
        fetch('/products/' + btn.getAttribute('data-quickview') + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(render)
          .catch(function () { bodyEl.innerHTML = '<div class="qv__loading">Unable to load.</div>'; });
      });
    });
  }

  /* ---------------- sticky add-to-cart ---------------- */
  function initStickyBar() {
    var bar = qs('[data-satc]');
    var anchor = qs('[data-add-btn]');
    if (!bar || !anchor) return;
    var form = anchor.closest('form');

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          // show bar once the main buy button has scrolled above the viewport
          var below = en.boundingClientRect.top > 0;
          bar.classList.toggle('is-visible', !en.isIntersecting && !below);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
      io.observe(anchor);
    }

    var addBtn = qs('[data-satc-add]', bar);
    on(addBtn, 'click', function () {
      if (addBtn.disabled || !form) return;
      Cart.add(form);
    });
  }

  /* ---------------- newsletter (graceful, lets Shopify form post) ---------------- */
  function initNewsletter() {
    qsa('[data-newsletter], .js-newsletter').forEach(function (form) {
      on(form, 'submit', function () {
        var btn = qs('button', form);
        if (btn) { btn.textContent = 'Joining\u2026'; }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    Cart.init();
    initQty();
    initGallery();
    initVariants();
    initAccordion();
    initSearch();
    initQuickView();
    initStickyBar();
    initNewsletter();
  });

  window.Batch9b = { Cart: Cart };
})();
